import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useAuth } from '@cash-web/shared-auth-data-access-context'
import { useArcadeMigrationFeatureFlag } from '@cash-web/shared-data-access-arcade-migration'
import { useCurrencySymbol } from '@cash-web/shared-feature-currency-symbol'
import { CashtagInput } from '@cash-web/shared-feature-form'

import { BaseBlocker, BlockerProps, SubmitButton } from '../../BaseBlocker/BaseBlocker'
import { useBlockerCashtag } from './useBlockerCashtag'

interface Props extends Partial<BlockerProps> {
  skippable?: boolean
}

export function BlockerCashtag({ skippable }: Props): React.ReactElement {
  const { t } = useTranslation()
  const { profile } = useAuth()
  const currencySymbol = useCurrencySymbol()
  const isArcadeMigrationEnabled = useArcadeMigrationFeatureFlag('apps')
  const { getButtonText, onGetCashStatus, onSubmit, showSupport, subtitle, title } = useBlockerCashtag()
  const form = useForm<{ cashtag: string }>({ mode: 'onSubmit', reValidateMode: 'onSubmit' }) // set both to onSubmit to allow for debounced validations
  const {
    formState: { isSubmitting },
  } = form

  return (
    <BaseBlocker
      mainText={title}
      secondaryText={subtitle}
      form={form}
      onSubmit={onSubmit}
      skippable={skippable}
      buttons={[
        <SubmitButton
          ariaLabel={getButtonText()}
          key={getButtonText()}
          text={getButtonText()}
          onClick={() => {
            if (showSupport) {
              window.open('/support/ACCOUNT_SETTINGS_CASHTAG_EDIT_TABS', '_blank')
            }
          }}
        />,
      ]}
    >
      <CashtagInput
        // eslint-disable-next-line @nx/workspace/no-new-useauth-profile-fields -- use useProfileCashtag from @cash-web/shared-data-access-core-profile
        defaultValue={profile?.cashtag}
        currencySymbol={currencySymbol}
        inputPrefix={currencySymbol}
        name="cashtag"
        onGetCashStatus={onGetCashStatus}
        disabled={isSubmitting}
        showLabel={!isArcadeMigrationEnabled}
        placeholder={t('Your unique name', { context: 'placeholder for form field asking user to create a cashtag' })}
      />
    </BaseBlocker>
  )
}
